import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';

interface IOption {
    name: string;
}

@Component({
    selector: 'app-custom-multiple-selector-editor',
    templateUrl: './custom-multiple-selector-editor.component.html',
    styleUrls: ['./custom-multiple-selector-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class CustomMultipleSelectorEditorComponent extends EditorComponentBase<string[] | null> implements OnInit {
    selectedItems?: IOption[];
    items?: IOption[];

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.additionalInfo.options) this.items = this.toIOptionFormat(this.additionalInfo.options);
        if (this.bindingProperty) this.selectedItems = this.toIOptionFormat(this.bindingProperty);
    }

    onSelectedItemsChange(event: any[]) {
        this.bindingProperty = event.length ? event.map((item) => item.name) : [];
        this.valueChange.emit();
        this.validate();
    }

    private toIOptionFormat(options: string[]) {
        return options.map((option) => ({ name: option }));
    }
}
